// extracted by mini-css-extract-plugin
var _1 = "clientsSection-module__clientsLogos___G09ZN";
export { _1 as "clientsLogos" }
